import * as React from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import store from "../Login/store";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Copyright(props: any) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {"Copyright © "}
      <Link color="inherit" href="https://mui.com/">
        
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: "#1976d2",
    },
    background: {
      default: "#f5f5f5",
    },
  },
});

const SignIn = observer(() => {
  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
  };
  const { t: translate } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    store.setNavigateFunction(navigate);
  }, [navigate]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        }}
      >
        <Container component="main" maxWidth="sm">
          <CssBaseline />
          <Paper
            elevation={6}
            sx={{
              padding: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              borderRadius: 3,
              backgroundColor: "rgba(255, 255, 255, 0.95)",
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/logo.png`}
                alt="Logo"
                style={{ width: "40%", marginBottom: "20px" }}
              />
              <Typography
                component="h1"
                variant="h6"
                align="center"
                sx={{
                  fontWeight: 500,
                  color: "#333",
                  marginBottom: 2,
                  lineHeight: 1.4,
                }}
              >
                Межведомственное взаимодействие по градостроительству и архитектуре
              </Typography>
              <Typography
                component="h2"
                variant="h5"
                align="center"
                sx={{
                  fontWeight: 600,
                  color: "#1976d2",
                  marginBottom: 3,
                }}
              >
                {translate("label:authorization:signIn")}
              </Typography>
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ width: "100%" }}
              >
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="login"
                  label={translate("label:authorization:email")}
                  name="login"
                  autoComplete="email"
                  autoFocus
                  onChange={(event) => store.handleChange(event)}
                  value={store.login}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  name="password"
                  label={translate("label:authorization:password")}
                  type="password"
                  id="password"
                  autoComplete="current-password"
                  error={store.errorPassword !== ""}
                  onChange={(event) => store.handleChange(event)}
                  value={store.password}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  sx={{
                    mt: 3,
                    mb: 2,
                    py: 1.5,
                    borderRadius: 2,
                    textTransform: "none",
                    fontSize: "1rem",
                    fontWeight: 600,
                    boxShadow: "0 4px 6px rgba(25, 118, 210, 0.3)",
                    "&:hover": {
                      boxShadow: "0 6px 10px rgba(25, 118, 210, 0.4)",
                    },
                  }}
                  onClick={() => {
                    store.onLogin();
                  }}
                >
                  {translate("label:authorization:signIn")}
                </Button>
                <Grid container justifyContent="center">
                  <Grid item>
                    <Link
                      href="/forgotPassword"
                      variant="body2"
                      sx={{
                        textDecoration: "none",
                        "&:hover": {
                          textDecoration: "underline",
                        },
                      }}
                    >
                      {translate("label:authorization:forgotPassword")}
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </Box>
            <Copyright sx={{ mt: 4 }} />
          </Paper>
        </Container>
      </Box>
    </ThemeProvider>
  );
});

export default SignIn;